import { useAppSelector } from 'app/hooks';
import appService from 'services/appService';

export const useUser = () => {
  const user = useAppSelector((state) => state.app.user);
  const userFromAuthToken = appService.getUserFromJwtToken();

  return user || userFromAuthToken;
};
